<script lang="ts">
  import EditableDataTable from 'scripts/global_components/EditableDataTable.svelte';
  import { navigate } from 'svelte-routing';
  import { slipItemTableConfig2 } from 'scripts/purchase/config/store';
  import type { ChoiceDisplayMap } from 'scripts/utils/types';

  export let slipList = [];
  export let choiceDisplayMap: ChoiceDisplayMap = {};

  let slipItemList = [];

  const updateSlipList = (slipList) => {
    slipItemList = [];
    slipList.forEach((item) => {
      slipItemList.push(...item.slipitem_set);
    });
  };

  $: updateSlipList(slipList);
  //$: console.log(slipItemList);
</script>

<div class="row p-2">
  <div class="col-12">
    <EditableDataTable
      on:trClick={(e) => navigate(`${e.detail.item.detail_url}`)}
      items={slipItemList}
      bind:tableConfig={$slipItemTableConfig2}
      bind:choiceDisplayMap
      primaryKey="pk"
      csvDownload={true}
      csvFields={Object.keys($slipItemTableConfig2)}
    />
  </div>
</div>
